import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconArrowDown = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" fill="none" className="icon-arrow-down" data-icon="icon-arrow-down" aria-hidden="true" {...props} ref={ref}><path d="M9.99935 4.16602V15.8327M9.99935 15.8327L15.8327 9.99935M9.99935 15.8327L4.16602 9.99935" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></svg>);
});

IconArrowDown.displayName = 'IconArrowDown';
